<template>
  <v-card class="pa-4">
    <v-container fluid>
      <v-row justify="center" align="center" class="mb-6">
        <v-icon class="mr-2" medium>assignment_ind</v-icon>
        <span class="title font-weight-light">Desempenho do Aluno no Plano de Aula: {{ idPlano }}</span>
      </v-row>

      <!-- Gráfico de Barras -->
      <v-row justify="center" class="mb-12">
        <div class="chart-container">
          <BarChart :chart-data="chartData" :options="chartOptions" :height="400" />
        </div>
      </v-row>

      <!-- Tabela de Infrações -->
      <v-row justify="center">
        <v-col cols="12" md="10">
          <v-data-table :headers="infraHeaders" :items="infracoes" class="elevation-1" dense>
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Infrações Registradas</v-toolbar-title>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<style scoped>
.chart-container {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
}
</style>

<script>
import { Bar } from 'vue-chartjs/legacy';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';
import AulaApi from '../../ws/aula';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: 'DesempenhoAluno',
  components: {
    BarChart: Bar,
  },
  props: {
    idPlano: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      aluno: {},
      chartData: null,
      infracoes: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'top' },
          title: {
            display: true,
            text: 'Desempenho por Aula',
          },
        },
        scales: {
          x: { stacked: true },
          y: { stacked: true },
        },
      },
      infraHeaders: [
        { text: 'Aula', value: 'aula' },
        { text: 'Infração', value: 'descricao' },
        { text: 'Pontos', value: 'pontos' },
      ],
    };
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.aluno = await this.$store.getters.getAluno;
      try {
        const response = await AulaApi.desempenhoAluno(this.idPlano);
        this.prepareChartData(response.data);
      } catch (error) {
        console.error('Erro ao buscar desempenho:', error);
      }
    },

    prepareChartData(dados) {
      const aulasMap = {};
      const infracoes = [];

      // Conta quantas vezes cada eventoDescricao apareceu por aula
      dados.forEach(item => {
        const aula = `Aula ${item.miaAgendaAula}`;
        const desc = item.eventoDescricao.trim();

        if (!aulasMap[aula]) aulasMap[aula] = {};

        if (item.categoriaTipoEvento === 1) {
          if (!aulasMap[aula][desc]) aulasMap[aula][desc] = 0;
          aulasMap[aula][desc] += 1; // ← Conta ocorrências, não pontos
        }

        if (item.categoriaTipoEvento === 6 && item.eventoPonto > 0) {
          infracoes.push({
            aula,
            descricao: desc,
            pontos: item.eventoPonto,
          });
        }
      });

      const labels = Object.keys(aulasMap).sort((a, b) => {
        return parseInt(a.replace('Aula ', '')) - parseInt(b.replace('Aula ', ''));
      });

      const descricoesUnicas = [...new Set(
        Object.values(aulasMap).flatMap(descMap => Object.keys(descMap))
      )];

      const datasets = descricoesUnicas.map(desc => ({
        label: desc,
        backgroundColor: this.getColorForLabel(desc),
        data: labels.map(label =>
          aulasMap[label].hasOwnProperty(desc) ? aulasMap[label][desc] : 0
        ),
      }));

      this.chartData = { labels, datasets };
      this.infracoes = infracoes;
    },

    getColorForLabel(label) {
      const map = {
        'Muito Bom': '#4caf50',
        'Bom': '#8bc34a',
        'Regular': '#ffeb3b',
        'Não desenvolvido': '#f44336',
      };
      return map[label] || '#ff9800';
    },
  },
};
</script>
